import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";
import pushModel from "@/mixin/store/api/pushModel";
import deleteModel from "../../mixin/store/api/deleteModel";
import axios from "axios";
import changeModel from "../../mixin/store/api/changeModel";

export default {
    actions: {
        fetchCustomers(context, page) {
            return fetchModels(context, 'customers', page, 'updateCustomers');
        },
        fetchAllCustomers(context) {
            if (context.state.customers.isNeedFetch) {
                return fetchModels(context, 'customers', null, 'updateCustomers');
            }
        },
        fetchCustomersTotalDebt(context, page) {
            return fetchModels(context, 'customers/totalDebt', page, 'updateCustomers');
        },
        fetchCustomer(context, id) {
            return fetchModel(context, 'customers', id, 'updateCustomer');
        },
        fetchDebt(context, id) {
            return fetchModel(context, 'customers/' + id + '/debt', null, 'updateDebt');
        },
        fetchCustomerSalesTotalAmount(context, id) {
            return fetchModel(context, 'customers/' + id + '/salesTotalAmount', null, 'updateCustomerSalesTotalAmount');
        },
        fetchDebtorCustomerCount(context) {
            return fetchModels(context, 'customer/debtor', null, 'updateDebtorCustomerCount')
        },
        fetchDebtFilter(context, searchItem) {
            let url = "debt_histories?page="  + searchItem.page + '&order%5Bid%5D=desc'

            if (searchItem.customerId) {
                url = url + '&sale.customer.id=' + searchItem.customerId
            }

            if (searchItem.before) {
                url = url + '&createdAt[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&createdAt[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateCustomerDebtHistory', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        putCustomer(context, data) {
            if (data.debt === '') {
                data.debt =  null;
                data.currency = null
            }

            return changeOrPushModel(context, data.url, data, 'updateCustomer')
        },
        pushCustomer(context, data) {
            if (data.debt === '') {
                data.debt =  null;
                data.currency = null
            }

            return pushModel(context, 'customers', data)
        },
        deleteCustomer(context, id) {
            return deleteModel(context, 'customers', id)
        },
        fetchAllCustomer(context, searchItem) {
            let url

            if (!searchItem) {
                url = "customers?page=1&order[id]=desc"
            } else {
                url = "customers?page=" + searchItem.page + "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateCustomers', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        searchCustomer(context, searchItem) {
            let url = "customers/totalDebt?page=" + searchItem.page;

            if (searchItem.givenName) {
                url = url + '&personGivenName=' + searchItem.givenName + '&'
            }

            if (searchItem.familyName) {
                url = url + '&personFamilyName=' + searchItem.familyName
            }

            if (searchItem.companyName) {
                url = url + '&companyName=' + searchItem.companyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateCustomers', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        payToCustomer(context, data) {
            return changeModel(context, 'customers/' + data.id + '/pay', data)
        },
        searchOneCustomer(context, searchItem) {
            let url = "customers?page=1"

            if (searchItem.givenName) {
                url = url + '&person.givenName=' + searchItem.givenName + '&'
            }

            if (searchItem.familyName) {
                url = url + '&person.familyName=' + searchItem.familyName
            }

            if (searchItem.companyName) {
                url = url + '&customerCompany.name=' + searchItem.companyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateCustomers', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        searchDebtorCustomers(context, searchItem) {
            let url = "customers?page=" + searchItem.page + '&debt[gt]=0';

            if (searchItem.givenName) {
                url = url + '&personGivenName=' + searchItem.givenName + '&'
            }

            if (searchItem.familyName) {
                url = url + '&personFamilyName=' + searchItem.familyName
            }

            if (searchItem.companyName) {
                url = url + '&companyName=' + searchItem.companyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateCustomers', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    mutations: {
        updateCustomers(state, data) {
            state.customers = data
            state.customers.isNeedFetch = false
        },
        updateCustomersIDB(state, data) {
            state.customers.models = data
        },
        updateCustomer(state, data) {
            state.customer = data
        },
        updateDebt(state, data) {
            state.debt = data
        },
        updateCustomerSalesTotalAmount(state, data) {
            state.totalAmount = data['hydra:member']
        },
        updateDebtorCustomerCount(state, data) {
            state.debtorCustomerCount = data
        },
        updateCustomerDebtHistory(state, data) {
            state.customerDebtHistory = data
        },
    },
    state: {
        debt: {},
        totalAmount: [],
        customer: {
            id: null,
            person: null,
            customerCompany: null,
            isCompany: true,
            avgReceipt: 0
        },
        customers: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        customerDebtHistory: {
            models: [],
            totalItems: 0,
        },
        debtorCustomerCount: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getCustomers(state) {
            return state.customers.models
        },
        findCustomerById: (state, getters) => (id) => {
            return getters.getCustomers.find(model => model.id === id)
        },
        getCustomer(state) {
            return state.customer
        },
        getDebt(state) {
            return state.debt
        },
        getCustomerSalesTotalAmount(state) {
            return state.totalAmount
        },
        getCustomersTotalCount(state) {
            return state.customers.totalItems
        },
        getDebtorCustomerCount(state) {
            return state.debtorCustomerCount.models
        },
        getCustomerDebtHistory(state) {
            return state.customerDebtHistory.models
        },
        getCustomerDebtTotalAmount(state) {
            return state.customerDebtHistory.totalItems
        },
    },
}
